import { towlotColorAliases, towlotColors } from './constants';

export const normalizeTowlotColorKey = (raw) =>
  (raw || '').toString().trim().toLocaleLowerCase('en-US').replace(/\s+/g, ' ');

export const mapTowlotColor = (raw) => {
  const key = normalizeTowlotColorKey(raw);
  if (!key) return 'N/A';
  if (towlotColorAliases[key]) return towlotColorAliases[key];
  const catalogMatch = towlotColors.find((c) => c.value.toLowerCase() === key);
  return catalogMatch ? catalogMatch.value : 'N/A';
};
